import { render, staticRenderFns } from "./AccessModalTitle.vue?vue&type=template&id=53c9f50d&scoped=true&"
import script from "./AccessModalTitle.vue?vue&type=script&lang=js&"
export * from "./AccessModalTitle.vue?vue&type=script&lang=js&"
import style0 from "./AccessModalTitle.vue?vue&type=style&index=0&id=53c9f50d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9f50d",
  null
  
)

export default component.exports